import { render, staticRenderFns } from "./RewardedCoins.vue?vue&type=template&id=79c27496&scoped=true&"
import script from "./RewardedCoins.vue?vue&type=script&lang=ts&"
export * from "./RewardedCoins.vue?vue&type=script&lang=ts&"
import style0 from "./RewardedCoins.vue?vue&type=style&index=0&id=79c27496&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c27496",
  null
  
)

export default component.exports